import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class CheckBoxService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getTitle = (): string => 'Check Boxes';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'check-boxes/0', 'title': 'Simple', 'theme': 'layout1' },
      { 'url': 'check-boxes/1', 'title': 'With Avatar', 'theme': 'layout2' },
      { 'url': 'check-boxes/2', 'title': 'Simple 2', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): any => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'Simple',
      'items':[
        {
          'id': 1,
          'title': 'Oberoi Amarvilas, Agra, India',
          "isChecked": true,
        },
        {
          'id': 2,
          'title': 'Pangu 7 Star Hotel, Beijing, China',
          "isChecked": false,
        },
        {
          'id': 3,
          'title': 'Plaza Athenee, Paris, France',
          "isChecked": false,
        },
        {
          'id': 4,
          'title': 'Corinthia Hotel, London, England',
          "isChecked": true,
        },
        {
          'id': 5,
          'title': 'Jade Mountain, St. Lucia',
          "isChecked": false,
        },
        {
          'id': 6,
          'title': 'Ritz-Carlton, Singapore',
          "isChecked": false,
        }
      ]
    }
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'With Avatar',
      'items':[
        {
          'id': 1,
          'title': 'Gibbs Farm, Karatu, Tanzania',
          "isChecked": true,
          'image': 'assets/imgs/avatar/1.jpg'
        },
        {
          'id': 2,
          'title': 'The Mulia, Bali, Indonesia',
          "isChecked": false,
          'image': 'assets/imgs/avatar/2.jpg'
        },
        {
          'id': 3,
          'title': 'Turtle Island, Fiji',
          "isChecked": true,
          'image': 'assets/imgs/avatar/3.jpg'
        },
        {
          'id': 4,
          'title': 'Ellerman House, Cape Town',
          "isChecked": false,
          'image': 'assets/imgs/avatar/4.jpg'
        },
        {
          'id': 5,
          'title': 'J.K. Place Firenze, Florencer',
          "isChecked": true,
          'image': 'assets/imgs/avatar/5.jpg'
        },
        {
          'id': 6,
          'title': 'The Oberoi, Mumbai',
          "isChecked": false,
          'image': 'assets/imgs/avatar/6.jpg'
        }
      ]
    }
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Simple 2',
      'items':[
        {
          'id': 1,
          'title': '45 Park Lane',
          'subtitle': 'LONDON, UNITED KINGDOM',
          "isChecked": true,
          'description': 'Art deco style in London'
        },
        {
          'id': 2,
          'title': 'The Alpina Gstaad',
          'subtitle': 'GSTAAD, SWITZERLAND',
          "isChecked": false,
          'description': 'Contemporary alpine high style'
        },
        {
          'id': 3,
          'title': 'Belmond El Encanto',
          'subtitle': 'SANTA BARBARA, CALIFORNIA',
          "isChecked": true,
          'description': 'An elegant Santa Barbara hideawayn'
        },
        {
          'id': 4,
          'title': 'Bernardus Lodge & Spa',
          'subtitle': 'CARMEL VALLEY, CALIFORNIA',
          "isChecked": false,
          'description': 'A wine lovers paradise in Carmel Valley'
        },
        {
          'id': 5,
          'title': 'Bulgari Hotel London',
          'subtitle': 'LONDON, UNITED KINGDOM',
          "isChecked": false,
          'description': 'Sleek style in Londons Knightsbridge'
        },
        {
          'id': 6,
          'title': 'Bulgari Resort Bali',
          'subtitle': 'BALI, INDONESIA',
          "isChecked": true,
          'description': 'Bali’s hidden clifftop resort'
        }
      ]
    }
  }

  load(item: any): Observable<any> {
    const that = this;
    that.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('checkBoxes/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            that.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            that.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        that.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
